import WaitlistForm from "./WaitlistForm";
import BrowserMockup from "./BrowserMockup";

const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 pb-28 md:pt-40 md:pb-32 overflow-hidden bg-radial-glow grain"
    >
      <div className="absolute inset-0 grid-bg pointer-events-none" aria-hidden="true" />
      <div
        className="absolute -top-32 left-1/2 -translate-x-1/2 h-[520px] w-[520px] rounded-full bg-indigo-600/20 blur-[120px] animate-pulse-slow pointer-events-none"
        aria-hidden="true"
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* eyebrow / brand mark */}
        <div className="flex justify-center animate-fade-up" style={{ animationDelay: "0ms" }}>
          <div
            data-testid="hero-eyebrow"
            className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] backdrop-blur px-3.5 py-1.5"
          >
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75 animate-ping" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-indigo-400" />
            </span>
            <span className="font-mono uppercase tracking-[0.2em] text-[10.5px] text-zinc-300">
              Equal · introducing EqualLayer
            </span>
          </div>
        </div>

        {/* Company title */}
        <div className="mt-10 flex justify-center animate-fade-up" style={{ animationDelay: "40ms" }}>
          <h1
            data-testid="hero-company-title"
            className="font-display font-semibold tracking-[-0.04em] text-white text-[88px] md:text-[128px] lg:text-[160px] leading-[0.9]"
          >
            Equal
          </h1>
        </div>

        {/* Headline */}
        <h2
          data-testid="hero-headline"
          className="animate-fade-up mt-6 text-center font-display font-medium tracking-tight text-balance text-white text-3xl md:text-5xl lg:text-6xl leading-[1.05]"
          style={{ animationDelay: "120ms" }}
        >
          A new way to{" "}
          <span className="relative inline-block">
            <span className="bg-gradient-to-r from-indigo-300 via-violet-300 to-sky-300 bg-clip-text text-transparent">
              interact
            </span>
            <svg
              className="absolute -bottom-2 left-0 w-full h-2 text-indigo-400/60"
              viewBox="0 0 200 10"
              fill="none"
              aria-hidden="true"
            >
              <path d="M2 6 Q 50 2, 100 6 T 198 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </span>{" "}
          with the web.
        </h2>

        {/* Subheadline */}
        <p
          data-testid="hero-subheadline"
          className="animate-fade-up mx-auto mt-7 max-w-2xl text-center font-body text-lg md:text-xl text-zinc-400 leading-relaxed text-balance"
          style={{ animationDelay: "180ms" }}
        >
          <span className="text-white font-medium">EqualLayer</span> is an intelligent interaction layer
          that lets you navigate, search, and take action across websites using natural commands.
        </p>

        {/* Supporting line */}
        <p
          data-testid="hero-support"
          className="animate-fade-up mt-4 text-center font-mono uppercase tracking-[0.22em] text-[11px] text-zinc-500"
          style={{ animationDelay: "220ms" }}
        >
          Built for accessibility · Designed for everyone
        </p>

        {/* Waitlist form */}
        <div
          id="waitlist"
          className="animate-fade-up mx-auto mt-10 max-w-xl"
          style={{ animationDelay: "280ms" }}
        >
          <WaitlistForm variant="hero" />
          <p className="mt-3 text-center font-mono uppercase tracking-[0.2em] text-[10.5px] text-zinc-500">
            Join early access · No spam · Built with the accessibility community
          </p>
        </div>

        {/* Browser mockup */}
        <div
          className="animate-fade-up relative mx-auto mt-20 max-w-5xl"
          style={{ animationDelay: "360ms" }}
          data-testid="hero-mockup"
        >
          <div className="absolute -inset-x-10 -top-10 -bottom-10 bg-gradient-to-b from-indigo-500/15 via-violet-500/5 to-transparent blur-3xl rounded-[48px] pointer-events-none" />
          <BrowserMockup />
        </div>
      </div>
    </section>
  );
};

export default Hero;
